var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"events-top-nav"},_vm._l((_vm.links),function(link,k){return _c('div',{key:k,staticClass:"events-top-nav__link-btn",class:{
      'events-top-nav__link-btn--active': _vm.currentType === link.id,
    },on:{"click":function($event){return _vm.handleClick(link)}}},[_vm._v(_vm._s(link.title))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }